import classes from "./zes-table.module.scss";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import classNames from "classnames";
import Grid from "@/components-library/layout/grid";
function ZesTable() {
  const columns = "1fr 1fr 1fr 1fr";
  const table = [
    {
      columns: [
        "Regione",
        "Piccole imprese",
        "Medie imprese",
        "Grandi imprese",
      ],
    },
    {
      columns: [
        "Campania",
        "Fino al 60% del costo",
        "Fino al 50% del costo",
        "Fino al 40% del costo",
      ],
    },
    {
      columns: [
        "Puglia",
        "Fino al 60% del costo",
        "Fino al 50% del costo",
        "Fino al 40% del costo",
      ],
    },
    {
      columns: [
        "Calabria",
        "Fino al 60% del costo",
        "Fino al 50% del costo",
        "Fino al 40% del costo",
      ],
    },
    {
      columns: [
        "Sicilia",
        "Fino al 60% del costo",
        "Fino al 50% del costo",
        "Fino al 40% del costo",
      ],
    },
    {
      columns: [
        "Basilicata",
        "Fino al 50% del costo",
        "Fino al 40% del costo",
        "Fino al 30% del costo",
      ],
    },
    {
      columns: [
        "Molise",
        "Fino al 50% del costo",
        "Fino al 40% del costo",
        "Fino al 30% del costo",
      ],
    },
    {
      columns: [
        "Sardegna",
        "Fino al 50% del costo",
        "Fino al 40% del costo",
        "Fino al 30% del costo",
      ],
    },
    {
      columns: [
        "Abruzzo",
        "Fino al 35% del costo",
        "Fino al 25% del costo",
        "Fino al 15% del costo",
      ],
    },
  ];
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classes.table}
    >
      {table.map((row, indexRow) => (
        <Grid
          key={`indexRowGridZes_${indexRow}`}
          columnGap={"2px"}
          columns={columns}
          className={classNames({
            [classes.header]: indexRow === 0,
            [classes.row]: indexRow !== 0,
          })}
        >
          {row.columns.map((column, index) => (
            <Label
              key={`indexRowColumnZes_${index}`}
              tag="p"
              size="md"
              color={indexRow === 0 ? "default" : "secondary"}
              align="start"
              weight="bold"
              className={classNames(classes.item, {
                [classes.firstColumn]: index === 0,
                [classes.secondColumn]: index === 1,
                [classes.thirdColumn]: index === 2,
                [classes.fourthColumn]: index === 3,
              })}
            >
              {column}
            </Label>
          ))}
        </Grid>
      ))}
    </Flex>
  );
}

export default ZesTable;
